import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    text: string;
    extendedStyles?: SmallHeadingAndTextStyles;
    isTrue?: boolean;
}

export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    extendedStyles?: SmallHeadingAndTextStyles;
    textStatus?: InjectableCss;
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
                        flex-direction: column;
            width: 100%;

            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "legend",
        css:css`
        color: #323232;
    font-size: 16px !important;
    text-transform: uppercase;
    font-weight: 500 !important;
    margin-bottom: 5px;

    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 10px !important;
                    display:none;
                `,
                css`
                font-size: 10px !important;
                display:none;

                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    textStatus: {
        css: css`
            width: 100%;
            font-size: 16px !important;
            color:#323232 !important;
font-style: normal;
    /* line-height:5px; */
    font-weight: 500;
    padding-top:3px;
    padding-bottom:3px;
    text-transform: capitalize;
    text-align:center !important;
    
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 12px;
                `,
                css`
                font-size: 12px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    text: {
        css: css`
            width: 100%;
            font-size: 11px !important;
            color:#fff !important;
font-style: normal;
    /* line-height:5px; */
    font-weight: 500;
    padding-top:3px;
    padding-bottom:3px;
    text-align:center !important;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 12px !important;
                `,
                css`
                font-size: 12px !important;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
};

const StatusLableAndHeadingOrderDetail: React.FunctionComponent<OwnProps> = ({ heading, text, isTrue, extendedStyles, ...otherProps }) => {
    const [styles] = React.useState(() => mergeToNew(smallHeadingAndTextStyles, extendedStyles));
    const colorMapping: { [key: string]: string } = {
    "in progress": "#858585",
    "not scheduled": "#D3D3D3",
    "delivered": "#3CB24D",
    "shipped": "#ff8b36",
    "out for delivery": "#2EAAE8",
    "ready for pickup": "#2EAAE8",
    "picked up":"#3CB24D",
    "ready to pickup": "#2EAAE8",
  };
  
  const getColor = (text: string): string => {
    return colorMapping[text] || colorMapping["in progress"];
  };

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            <Typography as="p" {...styles.heading} data-test-selector="heading">
                {heading}
            </Typography>
            {(isTrue && text ) ? <Typography as="p" {...styles.textStatus} data-test-selector={`text_${heading}`}>
                {text}
            </Typography> : <StyledWrapper style={{ backgroundColor: getColor(text?.toLocaleLowerCase()), width:"115px", borderRadius: "13px" }}>
            {text && <Typography as="p" {...styles.text} data-test-selector={`text_${heading}`}>
                {text}
            </Typography>}
            </StyledWrapper>}
            
        </StyledWrapper>
    );
};

export default StatusLableAndHeadingOrderDetail;
